import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable, EMPTY, BehaviorSubject } from 'rxjs';
import { FTLCustomer } from '../../app/models/ftl-customer';
import { AuthenticationService } from '../authentication/authentication.service';
import { MarginProfile, MarginProfileForCreate } from 'src/app/models/marginProfile';

@Injectable({
  providedIn: 'root'
})
export class MarginService {

  private customer: FTLCustomer;

  private _vanMarginProfile$ = new BehaviorSubject<MarginProfile>(null);
  private _reeferMarginProfile$ = new BehaviorSubject<MarginProfile>(null);
  private _flatbedMarginProfile$ = new BehaviorSubject<MarginProfile>(null);

  private _defaultVanMarginProfile$ = new BehaviorSubject<MarginProfile>(null);
  private _defaultReeferMarginProfile$ = new BehaviorSubject<MarginProfile>(null);
  private _defaultFlatbedMarginProfile$ = new BehaviorSubject<MarginProfile>(null);

  constructor(private http: HttpClient, private authService: AuthenticationService) {
    this.initializeAllDefaults();
  }

  getMarginProfile$(trailerGroup: string): Observable<MarginProfile> {
    switch(trailerGroup) {
      case "VAN":
        return this._vanMarginProfile$.asObservable();
      case "REEFER":
        return this._reeferMarginProfile$.asObservable();
      case "FLATBED":
        return this._flatbedMarginProfile$.asObservable();
      default:
        return this._vanMarginProfile$.asObservable();
    }
  }

  getDefaultMarginProfile$(trailerGroup: string): Observable<MarginProfile> {
    switch(trailerGroup) {
      case "VAN":
        return this._defaultVanMarginProfile$.asObservable();
      case "REEFER":
        return this._defaultReeferMarginProfile$.asObservable();
      case "FLATBED":
        return this._defaultFlatbedMarginProfile$.asObservable();
      default:
        return this._defaultVanMarginProfile$.asObservable();
    }
  }

  //Not implemented
  getFTLCustomersNameBeginsWith(term: string): Observable<FTLCustomer[]> {
    let encodedTerm = encodeURIComponent(term);
    return this.http.get<FTLCustomer[]>(environment.traxFtlApiServerUrl + '/customers?nameBeginsWith=' + encodedTerm + '&onlyLtlBrokers=true');
  }

  initializeMarginProfileByCustomerId(customerId: number, trailerGroup: string) {
    this.http.get<any>(environment.traxFtlApiServerUrl + '/marginprofiles/' + customerId + `?trailerGroup=${trailerGroup}`)
      .subscribe(
        profile => {
          switch(trailerGroup) {
            case "VAN":
              this._vanMarginProfile$.next(profile);
              //this._isVanProfilesSet$.next(true);
              break;
            case "REEFER":
              this._reeferMarginProfile$.next(profile);
              //this._isReeferProfilesSet$.next(true);
              break;
            case "FLATBED":
              this._flatbedMarginProfile$.next(profile);
              //this._isFlatBedProfilesSet$.next(true);
              break;
            default:
              this._vanMarginProfile$.next(profile);
              //this._isVanProfilesSet$.next(true);
          }
        }
      );
  }

  clearMarginProfiles() {
    this._vanMarginProfile$.next(null);
    this._reeferMarginProfile$.next(null);
    this._flatbedMarginProfile$.next(null);
  }

  clearMarginProfileByTrailerGroup(trailerGroup: string) {
    switch(trailerGroup) {
      case "VAN":
        this._vanMarginProfile$.next(null);
        break;
      case "REEFER":
        this._reeferMarginProfile$.next(null);
        break;
      case "FLATBED":
        this._flatbedMarginProfile$.next(null);
        break;
      default:
        this._vanMarginProfile$.next(null);
    }
  }

  createMarginProfile(profile: MarginProfileForCreate): Observable<any> {
    return this.http.post<Response>(`${environment.traxFtlApiServerUrl}/marginprofiles/create`, profile, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Headers': 'location',
        'Access-Control-Allow-Origin': '*'        
      }), observe: 'response'
    });
  }
  
  deleteMarginProfile(customerId: number, trailerGroup: string): Observable<any> {
    return this.http.put<Response>(`${environment.traxFtlApiServerUrl}/marginprofiles/` + customerId + `/deactivate?trailerGroup=${trailerGroup}`, null);
  }
  getCustomer(): FTLCustomer {
    return this.customer;
  }
  setCustomer(customer: FTLCustomer) {
    this.customer = customer;
  }

  private initializeAllDefaults() {
    this.http.get<any>(environment.traxFtlApiServerUrl + `/marginprofiles/default?trailerGroup=VAN`)
      .subscribe(
        profile => this._defaultVanMarginProfile$.next(profile)
      );
    this.http.get<any>(environment.traxFtlApiServerUrl + `/marginprofiles/default?trailerGroup=REEFER`)
      .subscribe(
        profile => this._defaultReeferMarginProfile$.next(profile)
      );
    this.http.get<any>(environment.traxFtlApiServerUrl + `/marginprofiles/default?trailerGroup=FLATBED`)
      .subscribe(
        profile => this._defaultFlatbedMarginProfile$.next(profile)
      );    
  }
  
}
